import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useDialog from "@/hooks/useDialog";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/solvook-ui-library";
import { Snackbar, Typography } from "@mui/material";
import { useState } from "react";
import useSnackbar, { IconWithSnackbarMessage, defaultSnackbarProps } from "../common/Snackbar";
import Icon from "../icon/Icon";
import { Bell, Check_Thin, Sizes } from "../icon/IconList";
import CheckLoginDialog from "../modal/CheckLoginDialog";
import { useBrandStore } from "./BrandProvider";
import { useBrandQuery } from "./queries/useBrandQuery";
import { useSubscribeBrandMutation } from "./queries/useSubscribeBrandMutation";
import { SubscribeCancelDialog } from "./SubscribeCancel";
export const CancelReasonValue = {
    0: "더 이상 이 브랜드의 자료가 필요하지 않아요.",
    1: "브랜드 상품에 불만족했어요.",
    2: "브랜드 알림이 너무 자주 와요.",
    3: "브랜드 업데이트 빈도가 너무 낮아요.",
    4: "브랜드 소통이 만족스럽지 않아요.",
    5: "기타"
};
export const SubscribeButton = ()=>{
    const name = useBrandStore((state)=>state.brand.name);
    const { data: brand  } = useBrandQuery({
        name
    });
    var _brand_isSubscribed;
    const isSubscribed = (_brand_isSubscribed = brand === null || brand === void 0 ? void 0 : brand.isSubscribed) !== null && _brand_isSubscribed !== void 0 ? _brand_isSubscribed : false;
    const [loginDialogOpen, setLoginDialogOpen] = useState(false);
    const [cancelRadioValue, setCancelRadioValue] = useState(null);
    const { isShowSnackbar , showSnackbar , hideSnackbar  } = useSnackbar();
    const { open , close , isOpen  } = useDialog();
    const { isLoggedIn  } = useAuthStore();
    const subscribeBrandMutation = useSubscribeBrandMutation();
    const onClickSubscribe = ()=>{
        if (!isLoggedIn) {
            setLoginDialogOpen(true);
            return;
        }
        if (isSubscribed) {
            open();
            return;
        }
        handleSubmit();
        //mx-187 소식받기 버튼 클릭시
        mixpanelEvent("Subscribe Button Clicked", {
            Position: "Brand Home",
            "Button Name": isSubscribed ? "소식 받는 중" : "소식 받기",
            "Brand Name": name
        });
    };
    const handleSubmit = async (etcReason)=>{
        // 진행 중인 mutation이 있으면 더블 클릭으로 인한 ±1 중복을 차단
        if (subscribeBrandMutation.isLoading) return;
        // 낙관적 업데이트 이후에도 흐름 분기가 유지되도록 클릭 시점의 상태를 캡쳐
        const wasSubscribed = isSubscribed;
        try {
            await subscribeBrandMutation.mutateAsync({
                name,
                isSubscribed: !wasSubscribed,
                ...wasSubscribed && cancelRadioValue ? {
                    cancelReason: etcReason || cancelRadioValue
                } : {}
            });
            if (wasSubscribed) {
                showSnackbar();
            }
        } catch (e) {
            window.alert(e.message);
        }
        close();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: isSubscribed ? "strokeSecondary" : "filledPrimary",
                onClick: onClickSubscribe,
                disabled: subscribeBrandMutation.isLoading,
                style: {
                    gap: "8px",
                    padding: "12px 20px"
                },
                children: isSubscribed ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            icon: Check_Thin,
                            size: Sizes.small,
                            color: "#6A708A"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: "소식 받는 중"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            icon: Bell,
                            color: "#fff",
                            size: Sizes.small
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            color: "background.paper",
                            children: "소식 받기"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(SubscribeCancelDialog, {
                open: isOpen,
                close: close,
                value: cancelRadioValue,
                setValue: setCancelRadioValue,
                handleSubmit: handleSubmit
            }),
            /*#__PURE__*/ _jsx(CheckLoginDialog, {
                open: loginDialogOpen,
                onClose: ()=>setLoginDialogOpen(false)
            }),
            /*#__PURE__*/ _jsx(Snackbar, {
                ...defaultSnackbarProps,
                open: isShowSnackbar,
                onClose: hideSnackbar,
                message: /*#__PURE__*/ _jsx(IconWithSnackbarMessage, {
                    icon: "success",
                    text: /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            color: "#FFF"
                        },
                        children: "이제 이 브랜드의 소식을 받지 않아요."
                    })
                })
            })
        ]
    });
};
